<template>
  <v-bottom-sheet
    v-model="navigationSheet"
    inset
    max-width="550px"
    :overlay-opacity="0.8"
    content-class="elevation-0"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        fab
        dark
        style="position: fixed; bottom: 76px; right: 16px; z-index: 5"
        float
        v-bind="attrs"
        v-on="on"
        color="primary"
      >
        <v-icon> mdi-dots-grid </v-icon>
      </v-btn>
    </template>
    <div class="mb-4 px-4 d-flex">
      <v-card class="pa-3 pb-2 rounded-lg">
        <v-tabs-items v-model="selectedTab">
          <v-tab-item
            v-for="[key, group] in Object.entries(filteredTabs)"
            :key="key"
            :value="key"
          >
            <div class="d-flex align-center mb-1 font-weight-bold text-h6">
              <v-icon left>{{ tabDetails[key].icon }}</v-icon>
              {{ tabDetails[key].title }}
            </div>
            <v-row dense class="mx-0">
              <v-col v-for="tab in group" :key="tab?.id" cols="4" sm="4" md="3">
                <v-card
                  @click="selectTab(tab, key)"
                  outlined
                  height="90px"
                  elevation="0"
                  class="pa-2"
                >
                  <div
                    class="d-flex align-center justify-center flex-column h-full text-center lh-1 gap-2"
                  >
                    <v-icon>{{ tab.icon }}</v-icon>
                    {{ tab.name }}
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>

        <div>
          <v-chip-group class="d-flex flex-wrap justify-center">
            <v-chip
              v-for="[key, group] in Object.entries(filteredTabs)"
              :key="key"
              class="ma-1 flex-1 chip-text-center"
              :color="selectedTab == key ? 'primary' : 'grey lighten-2'"
              :text-color="selectedTab == key ? 'white' : 'black'"
              :label="selectedTab !== key"
              @click="selectedTab = key"
              pill
            >
              <div class="flex-grow-1">
                <v-icon small>{{ tabDetails[key].icon }}</v-icon>
                <span class="ml-2">{{ tabDetails[key].title }}</span>
              </div>
            </v-chip>
          </v-chip-group>
        </div>
        <v-divider class="mt-2 mb-1" />

        <div class="d-flex justify-center ">
          <v-btn @click="navigationSheet = false" text block> Fechar </v-btn>
        </div>
      </v-card>
    </div>
  </v-bottom-sheet>
</template>
<script>
import { mapGetters } from "vuex";
import partyTabs from "@/definitions/partyTabs";

export default {
  name: "PartyBottomSheetNavigation",
  props: {
    party: {
      type: Object,
      default: null,
    },
    group: null,
  },
  data() {
    return {
      partyTabs,
      navigationSheet: false,
      selectedTab: this.group || "details",
      tabDetails: {
        details: {
          title: "Detalhes",
          icon: "mdi-eye",
        },
        management: {
          title: "Operacional",
          icon: "mdi-cog",
        },
        reports: {
          title: "Relatórios",
          icon: "mdi-chart-line",
        },
      },
    };
  },
  methods: {
    ...mapGetters("auth", ["hasPermission"]),
    selectTab(tab, key) {
      if (key === this.group) {
        window.location.replace("#" + tab.id);
        this.navigationSheet = false;
      } else {
        this.$router.push({
          name: `admin.party.${key}`,
          params: { partyId: this.party.id },
          hash: `#${tab.id}`,
        });
      }
    },
    filterTab(tab) {
      if (this.party?.isFree && tab.noFree) return false;
      if (!tab.permission) return true;
      return this.hasPermission(tab.permission);
    },
  },
  computed: {
    filteredTabs() {
      const filtered = Object.entries(this.partyTabs)
        .map(([key, tabs]) => {
          return [key, tabs.filter((tab) => this.filterTab(tab))];
        })
        .filter(([key, tabs]) => tabs.length > 0);
      return Object.fromEntries(filtered);
    },
  },
};
</script>
<style scoped lang="scss">
.chip-text-center {
  text-align: center;
  .v-chip__content {
    flex-grow: 1;
  }
}
</style>
